import { DATE_FORMAT } from "helpers/common";
import React from "react";
import { toast } from 'react-toastify';

const Columns = ({ }) => [
  {
    dataField: "purchaseID",
    text: "Purchase ID",
    formatter: (_, row) => <span className="text-capitalize">{row?.purchaseID}</span>,
  },
  {
    dataField: "energyPackageDetails",
    text: "Energy Package",
    formatter: (_, row) => <span className="text-capitalize">{row?.energyPackageDetails ? row?.energyPackageDetails?.name : "custom"}</span>,
  },
  {
    dataField: "energy",
    text: "Energy",
    formatter: (_, row) => <span className="text-capitalize">{row?.energy}</span>,
  },
  {
    dataField: "amount",
    text: "Amount",
    formatter: (_, row) => <span className="text-capitalize">{row?.amount}</span>,
  },
  {
    dataField: "prevEnergyBalance",
    text: "Prev Energy",
    formatter: (_, row) => <span className="text-capitalize">{row?.prevEnergyBalance}</span>,
  },
  {
    dataField: "newEnergyBalance",
    text: "New Energy",
    formatter: (_, row) => <span className="text-capitalize">{row?.newEnergyBalance}</span>,
  },
  {
    dataField: "transactionHash",
    text: "Transaction Hash",
    formatter: (_, row) => {
      const hash = row?.transactionHash;
      const network = row?.network;
      const shortened = hash ? `${hash.slice(0, 4)}...${hash.slice(-4)}` : "";

      const baseUrl =
        network === "mainnet"
          ? "https://tonviewer.com/transaction/"
          : "https://testnet.tonviewer.com/transaction/";

      return (
        <a
          href={`${baseUrl}${hash}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text"
        >
          {shortened}
        </a>
      );
    },
  },
  {
    dataField: "senderWalletAddress",
    text: "Sender Wallet Address",
    formatter: (_, row) => {
      const address = row?.senderWalletAddress;
      const shortened = address ? `${address.slice(0, 4)}...${address.slice(-4)}` : "";

      const handleCopy = () => {
        if (address) {
          navigator.clipboard.writeText(address);
          toast.success("Wallet address copied!");
        }
      };

      return (
        <span
          className="text"
          style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
          onClick={handleCopy}
          title="Click to copy"
        >
          {shortened}
        </span>
      );
    },
  },
  {
    dataField: "transactionCompletedAt",
    text: "Trx Completed At",
    formatter: (_, row) => <span className="text-capitalize">{row?.transactionCompletedAt ? DATE_FORMAT(row?.transactionCompletedAt) : "--"}</span>,
  },
  {
    dataField: "date_created_utc",
    text: "Created At",
    formatter: (_, row) => <span className="text-capitalize">{row?.date_created_utc && DATE_FORMAT(row?.date_created_utc)}</span>,
  }
];
export default Columns;
